var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1604 21.7942C32.3137 17.9314 33.3903 16 35 16C36.6097 16 37.6863 17.9314 39.8396 21.7942L40.3967 22.7936C41.0086 23.8913 41.3146 24.4401 41.7916 24.8023C42.2686 25.1644 42.8628 25.2988 44.051 25.5677L45.1328 25.8124C49.3142 26.7585 51.405 27.2316 51.9024 28.8311C52.3998 30.4307 50.9745 32.0974 48.1238 35.4309L47.3863 36.2933C46.5763 37.2405 46.1712 37.7142 45.989 38.3001C45.8068 38.8861 45.8681 39.518 45.9905 40.7818L46.102 41.9325C46.533 46.38 46.7485 48.6038 45.4462 49.5924C44.144 50.5809 42.1865 49.6796 38.2714 47.877L37.2585 47.4106C36.1459 46.8984 35.5897 46.6422 35 46.6422C34.4103 46.6422 33.8541 46.8984 32.7415 47.4106L31.7286 47.877C27.8135 49.6796 25.856 50.5809 24.5538 49.5924C23.2515 48.6038 23.467 46.38 23.898 41.9325L24.0095 40.7818C24.1319 39.518 24.1932 38.8861 24.011 38.3001C23.8288 37.7142 23.4237 37.2405 22.6137 36.2933L21.8762 35.4309C19.0255 32.0974 17.6002 30.4307 18.0976 28.8311C18.595 27.2316 20.6858 26.7585 24.8672 25.8124L25.949 25.5677C27.1372 25.2988 27.7314 25.1644 28.2084 24.8023C28.6854 24.4401 28.9914 23.8913 29.6033 22.7936L30.1604 21.7942Z",
    stroke: "url(#paint0_linear_269_691)",
    strokeWidth: 2.55
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_691",
    x1: 35,
    y1: 16,
    x2: 35,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCon1);
export default __webpack_public_path__ + "static/media/con1.ddbb98b5c1bdef60cc847d33339417ea.svg";
export { ForwardRef as ReactComponent };